import { render, staticRenderFns } from "./DoctorProcess.vue?vue&type=template&id=fc650a96&scoped=true"
import script from "./DoctorProcess.vue?vue&type=script&lang=js"
export * from "./DoctorProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc650a96",
  null
  
)

export default component.exports